export default __webpack_public_path__ + "static/media/paint-brush.20de4229.png";